/**
 * Possible avatar sizes
 */
export enum AvatarSize {
  /**
   * 50x50
   */
  SMALL = 'small',
  /**
   * 150x150
   */
  MEDIUM = 'medium',
  /**
   * 300x300
   */
  LARGE = 'large',
  /**
   * 600x600
   */
  X_LARGE = 'xlarge',
}

/**
 * To allow proper mapping when using the picture elementt
 *
 * @description https://developer.mozilla.org/en-US/docs/Web/HTML/Element/picture
 *
 * @example A Vue.js example
    <picture>
      <source :srcset="urlXLarge" :media="`(min-width: ${AvatarSizePixels.X_LARGE})`">
      <source :srcset="urlLarge" :media="`(min-width: ${AvatarSizePixels.LARGE})`">
      <source :srcset="urlMedium" :media="`(min-width: ${AvatarSizePixels.MEDIUM})`">
      <source :srcset="urlSmall" :media="`(min-width: ${AvatarSizePixels.SMALL})`">
      <img :src="urlMedium" alt="avatar">
    </picture>
 */
export const AvatarSizePixels: Record<AvatarSize, string> = {
  [AvatarSize.SMALL]: '50px',
  [AvatarSize.MEDIUM]: '150px',
  [AvatarSize.LARGE]: '300px',
  [AvatarSize.X_LARGE]: '600px',
}

export interface AvatarInfo {
  readonly isDefault: boolean
  readonly urlSmall: string
  readonly urlMedium: string
  readonly urlLarge: string
  readonly urlXLarge: string
}
